var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcDeleteRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "ic-trash-outline",
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.037,
    height: 16.042,
    viewBox: "0 0 15.037 16.042",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "trash-alt-regular",
    d: "M9,13.034H9.8a.39.39,0,0,0,.4-.376V5.89a.39.39,0,0,0-.4-.376H9a.39.39,0,0,0-.4.376v6.768A.39.39,0,0,0,9,13.034ZM14.5,2.507H11.734L10.593.73A1.638,1.638,0,0,0,9.21,0H5.826A1.638,1.638,0,0,0,4.445.73L3.3,2.507H.537a.52.52,0,0,0-.537.5v.5a.52.52,0,0,0,.537.5h.537V14.538a1.56,1.56,0,0,0,1.611,1.5h9.667a1.56,1.56,0,0,0,1.611-1.5V4.011H14.5a.52.52,0,0,0,.537-.5v-.5A.52.52,0,0,0,14.5,2.507ZM5.768,1.6A.2.2,0,0,1,5.941,1.5H9.1a.2.2,0,0,1,.173.091l.586.911H5.182Zm6.584,12.943H2.685V4.011h9.667Zm-7.116-1.5h.806a.39.39,0,0,0,.4-.376V5.89a.39.39,0,0,0-.4-.376H5.236a.39.39,0,0,0-.4.376v6.768A.39.39,0,0,0,5.236,13.034Z",
    transform: "translate(0 0)",
    fill: "#e24c4b"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcDeleteRed);
export default __webpack_public_path__ + "static/media/ic-delete-red.79e2938538e1a820304a0bdadb088d97.svg";
export { ForwardRef as ReactComponent };